import { sourceDetailsType } from "@App/appReducerType";

declare global {
  interface Window {
    getCookie: any;
  }
}
const getFormattedSourceDetails = (isWhitelabel = false, partner_uuid = "") => {
  const sourceData: any = {};
  if (window && window?.getCookie) {
    let referrer = window.getCookie("referrer");
    let initial_referrer = window.getCookie("initial_referrer");
    const referring_domain = window.getCookie("referring_domain");
    const initial_referring_domain = window.getCookie("initial_referring_domain");
    const initial_utm_params = window.getCookie("initial_utm_params");
    if (referrer) {
      if (referrer.length > 300) {
        referrer = referrer.slice(0, 300);
      }
      sourceData.referrer = referrer;
    }
    if (initial_referrer) {
      if (initial_referrer.length > 300) {
        initial_referrer = initial_referrer.slice(0, 300);
      }
      sourceData["initial_referrer"] = initial_referrer;
    }
    if (referring_domain) {
      sourceData["referring_domain"] = referring_domain;
    }
    if (initial_referring_domain) {
      sourceData["initial_referring_domain"] = initial_referring_domain;
    }

    sourceData["current_url"] = window?.location?.href || "";

    if (initial_utm_params) {
      const obj: any = {};
      const array = initial_utm_params.split("|");
      array.forEach((item: any) => {
        const arr: any = item.split("=");
        if (arr.length > 0) {
          // eslint-disable-next-line prefer-destructuring
          obj[arr[0]] = arr[1];
        }
      });

      if (isWhitelabel) {
        obj["utm_source"] = partner_uuid;
        obj["utm_medium"] = "whitelabelv2";
        obj["utm_campaign"] = "partner";
      }
      const utmParamKeys = [
        "utm_source",
        "utm_campaign",
        "utm_content",
        "utm_medium",
        "utm_term",
        "utm_group",
        "gclid",
        "fbclid",
        "msclkid",
        "keyword",
        "wbraid",
        "gbraid",
        "bd_vid",
      ];
      utmParamKeys.forEach((key: any) => {
        if (obj[key]) {
          sourceData[key] = obj[key];
        }
      });
    }
  }
  return sourceData;
};

export const getFormattedSourceDetailsOnServer = (
  cookies: any,
  queryParams: any,
): Partial<sourceDetailsType> => {
  const sourceData: any = {};

  const utmParams = { ...cookies, ...queryParams };

  if (utmParams.referrerValue) {
    if (utmParams.referrerValue.length > 300) {
      utmParams.referrerValue = utmParams.referrerValue.slice(0, 300);
    }
    sourceData.referrer = utmParams.referrerValue;
  }
  if (utmParams.initialReferrerValue) {
    if (utmParams.initialReferrerValue.length > 300) {
      utmParams.initialReferrerValue = utmParams.initialReferrerValue.slice(0, 300);
    }
    sourceData["initial_referrer"] = utmParams.initialReferrerValue;
  }
  if (utmParams.referring_domain) {
    sourceData["referring_domain"] = utmParams.referring_domain;
  }
  if (utmParams.initial_referring_domain) {
    sourceData["initial_referring_domain"] = utmParams.initial_referring_domain;
  }

  sourceData["current_url"] = "";
  if (utmParams.utm_source) {
    sourceData["utm_source"] = utmParams.utm_source;
  }
  if (utmParams.initial_utm_params) {
    const obj: any = {};
    const array = utmParams.initial_utm_params.split("|");
    array.forEach((item: any) => {
      const arr: any = item.split("=");
      if (arr.length > 0) {
        // eslint-disable-next-line prefer-destructuring
        obj[arr[0]] = arr[1];
      }
    });
    const utmParamKeys = [
      "utm_source",
      "utm_campaign",
      "utm_content",
      "utm_medium",
      "utm_term",
      "utm_group",
      "gclid",
      "fbclid",
      "msclkid",
      "keyword",
      "wbraid",
      "gbraid",
      "bd_vid",
    ];
    utmParamKeys.forEach((key: any) => {
      if (obj[key]) {
        sourceData[key] = obj[key];
      }
    });
  }
  return sourceData;
};

export default getFormattedSourceDetails;
